import cx from 'classnames';
import { INACTIVE_USER } from 'mk/autogenerated/translations/InactiveUserBadge.0e544870b199a511e533fe7c86265073'
import React from 'react';
import styles from './InactiveUserBadge.mscss';

interface OwnProps {
    className?: string;
}

type Props = OwnProps;

const InactiveUserBadge: React.FunctionComponent<Props> = ({ className }) => (
    <span className={cx(styles.InactiveUserBadge, className)}>
        {INACTIVE_USER}
    </span>
);

InactiveUserBadge.displayName = 'InactiveUserBadge';

export default React.memo<Props>(InactiveUserBadge);
